// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"speech-voices_wrapper__33eAA"};